<!-- eslint-disable -->
<template lang="pug">
    .pause-screen(v-if="isGamePaused && !isSingleScreen")
        svg-icon(name="pause" :aria-hiddent="true" height="50px" width="50px")
    div(v-else, :class=`[{'digits-area__result': result, 'digits-area__result_x2': isX2}, multiplayerClass]`)
        cs-loader(v-if="isArrayLoading")
        div(v-else)
            .number-container(v-if="currentNumber && !stopGame && !gameEnd")
                .number(
                    :class=`[{
                            'number_blue': !oddIndex,
                            'number_green': oddIndex,
                        },
                        exampleActionClass
                    ]`
                    :style="{'color': playersNumber !== 0 && colorForStudent + '!important'}"
                )
                    .digits-area__random-num(v-if='parameters.extraOptions.motion')
                        .digits-area__moving-num(:style="numberStyle")
                            | {{ currentNumber }}
                    span(v-else, v-html="(currentNumber > 0 ? '&plus;' : '&minus;') + numberOutput" :style="currentNumberStyles")
                    .digits-area__random-img-container
                        img.digits-area__random-img(:src='image', :style="imageStyle")
            template(v-if="stopGame")
                add-and-sub-examples-viewer(
                    v-if="ableToShowAnswer && parameters.dictation && parameters.amountOfExamples >= examplesArray.length"
                    :examplesArray="examplesArray"
                )
                .answer(v-else-if="!parameters.dictation && !gameEnd")
                    label.answer-label(v-if="stopGame && !result") {{ $i18n.t('trainer.trainer_gamePlayBox_answer') }}:
                    span.correct-answer(v-if="result && !correct" :class="correctAnswerClass")
                        | {{ $i18n.t('trainer.trainer_gamePlayBox_rightAnswer') }}: {{ correctAnswer }}
                    .answer__box
                        input.answer-input(
                            :class=`{
                            'answer-input_correct': correct,
                            'answer-input_incorrect': result && !correct,
                            'answer-input_with-result-icon': isBattle,
                        }`,
                        maxlength="9",
                        @keydown.prevent.enter="enterHandler",
                        @input.prevent="answer = handleDigitInput($event)"
                        ref="input"
                        :disabled="result"
                    )
                    svg-icon.result-icon(
                        :class="{'result-icon_correct': correct, 'result-icon_incorrect': result && !correct}",
                        v-if="correct || (result && !correct)",
                        size="big",
                            :name="correct ? 'circle-check' : 'circle-close'"
                        )
                    cs-button.answer-button(
                        color="blue",
                        type="button",
                        @click="checkAnswer(!isSingleScreen)",
                        v-if="!isX2",
                    ) {{ $i18n.t('trainer.trainer_gamePlayBox_reply') }}
            .result(v-if="(result || (playersNumber >= 1 && !result && gameEnd)) && !isBattle")
                template(v-if="playersNumber >= 1 && !result && gameEnd")
                    .help-text__end-multiplayer-game
                        | {{ $i18n.t('common.common_gameSettings_endGame') }}
                template(v-else-if='showProblem')
                    .problem-wrapper
                        .problem-header(:style="{'color': playersNumber !== 0 && colorForStudent}")
                            | {{ $i18n.t('trainer.trainer_gamePlayBox_example') }}
                        .problem-body(:style="{'padding-left: 2rem': isX2, 'color': playersNumber !== 0 && colorForStudent}")
                            template(v-for='number in numbers')
                                span
                                    template(v-if='number > 0') +
                                    template(v-else) −
                                    | {{ Math.abs(number) }}
                            | = ?
                        .problem-header.problem-header_your-answer
                            | {{ $i18n.t('trainer.trainer_gamePlayBox_yourAnswer') }}:
                        .my-answer(:style="{'padding-left: 2rem': isX2}")
                            | {{ answer !== '' ? answer : '—' }}
                        portal-target(v-if='!isX2', :name='portalName')
                template(v-else)
                    .result-container_x2.result-container_multiplayer(v-if='isX2 || playersNumber >= 1')
                        .digits-area__reaction-image-container
                            result-image.digits-area__reaction-image(
                                :status="correct ? 'success' : 'failure'",
                                :is-multiplayer="!isSingleScreen"
                            )
                        .digits-area__answers(v-if="parameters.showAnswer")
                            .digits-area__answer.digits-area__answer_x2(
                                :class="[correct ? 'digits-area__answer_correct' : 'digits-area__answer_incorrect']"
                            )
                                div
                                    | {{ $i18n.t('trainer.trainer_gamePlayBox_answer') }}
                                .digits-area__answer-number
                                    | {{ answer !== '' ? answer : '—' }}
                            .digits-area__answer.digits-area__answer_correct.digits-area__answer_x2
                                div
                                    | {{ $i18n.t('trainer.trainer_gamePlayBox_right') }}
                                .digits-area__answer-number
                                    | {{ correctAnswer }}
                        portal-target(v-if="playersNumber >= 1" :name="portalName")
                    template(v-else)
                        .digits-area__answer-block(:class="{'digits-area__answer-block_without-answers': !parameters.showAnswer}")
                            .digits-area__answer(v-if="parameters.showAnswer" :class="[correct ? 'digits-area__answer_correct' : 'digits-area__answer_incorrect']")
                                div
                                    | {{ $i18n.t('trainer.trainer_gamePlayBox_answer') }}
                                .digits-area__answer-number
                                    | {{ answer }}
                            .digits-area__reaction-image-container
                                result-image.digits-area__reaction-image(
                                    :status="correct ? 'success' : 'failure'",
                                    :is-multiplayer="!isSingleScreen"
                                )
                            .digits-area__answer.digits-area__answer_correct(v-if="parameters.showAnswer")
                                div
                                    | {{ $i18n.t('trainer.trainer_gamePlayBox_right') }}
                                .digits-area__answer-number
                                    | {{ correctAnswer }}
                        portal-target(v-if='!isX2', name='exitButtons')
            .result_dictation(v-if="exampleEnded || ableToShowButton")
                result-image.result__image(is-answer-turtle)
                .result__buttons
                    cs-button(
                        color="blue"
                        v-if="!exampleEnded && ableToShowButton"
                        @click="showAnswer"
                        v-focus=""
                    )
                        | {{ $i18n.t('trainer.trainer_gamePlayBox_showAnswers') }}
</template>

<script>
    /*eslint-disable*/
    import {mapState} from 'vuex';
    import generateNumbers from '../../../../utils/trainer/generateNumbers';
    import _ from 'lodash';
    import answerDurationMixin from '../../../../utils/trainer/answerDurationMixin';
    import ResultImage from '../ResultImage.vue'
    import AddAndSubExamplesViewer from '../../../trainer/games/AddAndSubExamplesViewer.vue'
    import handleDigitInput from "../../../../utils/trainer/handleDigitInput";

    const MAX_VOICE_OVER_DIFFICULTY = 3;
    const MAX_IMAGE_HEIGHT = 378;
    const MAX_IMAGE_WIDTH = 150;
    const PLAY_BOX_PADDING_SUMMARY = 120;
    const GAME_FIELD_PADDING = 30;
    const SIDE_PADDING_SUMMARY = 50;
    const MINIMAL_WIDTH_OF_GAME_INFO = 100;

    export default {
        components: {AddAndSubExamplesViewer, ResultImage},
        props: {
            isBattle: Boolean,
            parameters: Object,
            exerciseId: [Number, String],
            showProblem: Boolean,
            stopGame: Boolean,
            minDurationForVoiceActing: Object,
            isX2: Boolean,
            areaIndex: String,
            getLastNumbers: Boolean,
            showCartoon: Boolean,
            delay: {
                type: [Boolean, Number],
                default: 0
            },
            isSingleScreen: Boolean,
            checkMultiplayerAnswers: Boolean,
            examplesArray: Array,
            isAbacusOpened: Boolean,
            isGamePaused: {
                type: Boolean,
                default: true,
            },
            playersNumber: {
                type: Number,
                default: 0
            },
            colorForStudent: {
                type: String,
                default: ''
            },
            indexOfPlayBox: {
                type: Number,
                default: 0
            },
            gameEnd: {
                type: Boolean,
                default: false
            }
        },
        mounted () {
            if (this.isSingleScreen) {
                this.$createjs.Sound.removeAllEventListeners();
                this.$createjs.Sound.addEventListener('fileload', () => {
                    this.loadedSound++;
                });
                this.$createjs.Sound.alternateExtensions = ["mp3"];
            }
            if (this.$refs.input) {
                this.$refs.input.focus();
            }
        },
        updated () {
            if (this.delay === 0 && this.$refs.input && !this.isFocused) {
                this.$refs.input.focus();
                this.isFocused = true;
            }
        },
        watch: {
            isGamePaused: {
                handler (value) {
                    if (!value) {
                        this.isArrayLoading = true;
                        this.$emit('index', 0);
                        setTimeout(this.getNumbers, this.delay);
                    }
                },
                immediate: true,
            },
            currentNumber (val) {
                this.$emit('displayNumbers', val);
                if (!val) {
                    this.$emit('exampleEnded');
                    if (this.parameters.dictation) {
                        this.exampleEnded = true;
                        this.ableToShowButton = true;
                        this.startDictationTimer();
                    }
                }
            },
            isVoiceOverAllowed () {
                this.isVoice = !this.isVoice;
            },
            index: {
                handler (val) {
                    if (val < this.numbers.length) {
                        if (val === 0) {
                            this.$emit('showTurtle', true);
                        }
                        this.getDataFromArray();
                    } else if (val) {
                        this.$emit('showTurtle', false);
                        this.$emit('stopGame', true);
                    }
                },
                immediate: true,
            },
            correct (val) {
                if (val) {
                    this.$emit('answer', true);
                } else if (val !== null) {
                    this.$emit('answer', false);
                }
            },
            isArrayLoading (val, oldVal) {
                if (!val && oldVal) {
                    this.$emit('opponentNumbers', _.shuffle(this.numbers));
                    //todo: remove condition for locale and add necessary sounds
                    if (
                            this.difficult <= MAX_VOICE_OVER_DIFFICULTY
                            && !this.parameters.extraOptions.x2
                            && this.parameters.extraOptions.voiceOver
                            && this.isVoiceOverAllowed
                    ) {
                        this.$createjs.Sound.registerSounds(this.soundObjects);
                    } else {
                        this.index = 0;
                        this.$emit('start');
                    }
                }
            },
            loadedSound (val) {
                if (val === this.soundObjects.length) {
                    this.index = 0;
                    this.$emit('start');
                }
            },
            stopGame (val) {
                if (val && !this.isGamePaused) {
                    this.trackTime();
                }
            },
            checkMultiplayerAnswers (val) {
                if (val) {
                    this.checkAnswer(true);
                }
            }
        },
        data () {
            return {
                numbers: [],
                answer: '',
                index: null,
                result: false,
                correct: null,
                correctAnswer: null,
                imgPosition: {
                    x: null,
                    y: null,
                },
                numPosition: {
                    x: null,
                    y: null
                },
                image: null,
                nextImg: null,
                loadedSound: 0,
                isArrayLoading: false,
                isFocused: false,
                isVoice: true,
                exampleEnded: false,
                ableToShowAnswer: false,
                ableToShowButton: false,
                dictationTimer: null,
                dictationTime: 0,
                currentNumberIndex: 0
            }
        },
        mixins: [generateNumbers, answerDurationMixin],
        methods: {
            handleDigitInput,
            startDictationTimer () {
                this.dictationTimer = setInterval(() => {
                    this.dictationTime++;
                    if (this.dictationTime === this.parameters.timeForAnswer) {
                        clearInterval(this.dictationTimer);
                        this.$createjs.Sound.removeSounds(this.soundObjects);
                        this.exampleEnded = false;
                        this.ableToShowAnswer = false;
                        this.$emit('finish');
                        this.$emit('exampleEnded', this.numbers);
                    }
                }, 1000);
            },
            getNumbers () {
                if (this.getLastNumbers) {
                    this.numbers = this.$store.state.trainer.previousNumbers[this.areaIndex];
                    this.correctAnswer = this.$store.state.trainer.correctAnswers[this.areaIndex];
                } else {
                    this.generateArrayOfNumbers();
                }
                this.isArrayLoading = false;
            },
            checkAnswer (isMultiplayer = false) {
                if (this.answer !== '' || isMultiplayer) {
                    this.$nextTick(() => this.$emit('finish'));
                    this.$createjs.Sound.removeSounds(this.soundObjects);
                    this.result = true;
                    this.$store.commit('setPreviousNumbers', {position: this.areaIndex, numbers: this.numbers});
                    this.$store.commit(`set${_.capitalize(this.areaIndex)}CorrectAnswer`, this.correctAnswer);
                    if (!this.isBattle) {
                        this.$emit('stopGame', false);
                    } else {
                        setTimeout(() => this.$emit('stopGame', false), 2000);
                    }
                    this.answer = this.answer && +this.answer.replace(",", ".");
                    this.correct = this.answer === this.correctAnswer;
                    this.stopTracking();
                }
            },
            getDataFromArray () {
                if (this.index === this.numbers.length) {
                    this.$emit('stopGame', true);
                } else if (
                        !this.isX2
                        && this.parameters.extraOptions.voiceOver
                        && this.isVoiceOverAllowed
                ) {
                    let operationInstance = this.$createjs.Sound;
                    if (this.difficult <= MAX_VOICE_OVER_DIFFICULTY && !this.isSpanish) {
                        if (this.numbers[this.index] < 0) {
                            operationInstance = operationInstance.play('minus');
                        } else {
                            operationInstance = operationInstance.play('plus');
                        }
                    }
                    let abs = Math.abs(this.numbers[this.index]);
                    if (this.isSingleScreen) {
                        if (this.isSpanish) {
                            this.playDigitSound([this.numbers[this.index]]);
                            operationInstance.volume = 0.6;
                        } else {
                            operationInstance.on('complete', () => {
                                let splittedNumber = this.splittableNumber
                                    ? this.splitNumber(abs)
                                    : [abs];
                                this.playDigitSound(splittedNumber);
                            }, this);
                            operationInstance.volume = 0.6;
                        }

                    }
                }
                setTimeout(() => {
                    this.index++;
                    this.$emit('index', this.index);
                }, this.parameters.speed * 1000);
            },
            playDigitSound (splittedNumber) {
                let instance = this.$createjs.Sound.play(splittedNumber[0]);
                instance.volume = 0.6;
                splittedNumber.splice(0, 1);
                if (splittedNumber.length) {
                    instance.on('complete',() => {
                        this.playDigitSound(splittedNumber);
                    }, this);
                }
            },
            splitNumber (number) {
                let splittedNumber = [];
                if (number > 999) {
                    splittedNumber.push(Math.floor(number / 1000) * 1000);
                    number %= 1000;
                }
                if (number && number > 99) {
                    if (number % 100 <= 20 && this.isBulgarian) {
                        splittedNumber.push(Math.floor(number / 100) * 100 + '+');
                    } else {
                        splittedNumber.push(Math.floor(number / 100) * 100);
                    }
                    number %= 100;
                }
                if (number) {
                    if (number <= 20) {
                        splittedNumber.push(number);
                    } else {
                        let decadeNumber = Math.floor(number / 10) * 10;
                        if (this.isBulgarian && number % 10) {
                            decadeNumber += '+';
                        }
                        splittedNumber.push(decadeNumber);
                        if (number % 10) {
                            splittedNumber.push(number % 10);
                        }
                    }
                }
                return splittedNumber;
            },
            enterHandler () {
                if (!this.isX2) {
                    this.checkAnswer(!this.isSingleScreen);
                } else {
                    this.$emit('enterKeyUp');
                }
            },
            showAnswer () {
                this.ableToShowAnswer = true;
                this.ableToShowButton = false;
                this.$emit('clearTimer');
            }
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
                previousNumbers: state => state.trainer.previousNumbers
            }),
            numberOutput () {
                this.currentNumberIndex += 1;
                return this.parameters.fractions
                        ? Math.abs(this.currentNumber).toFixed(this.parameters.fractionalPart)
                        : Math.abs(this.currentNumber);
            },
            currentNumber () {
                let gameInfoWidth = MINIMAL_WIDTH_OF_GAME_INFO + SIDE_PADDING_SUMMARY;
                let gameInfoBlock = document.querySelector('.game-info__container');
                if (gameInfoBlock) {
                    gameInfoWidth = gameInfoBlock.clientWidth + SIDE_PADDING_SUMMARY;
                }
                let gameInfoHeight = 0;
                if (this.isX2 && gameInfoBlock) {
                    gameInfoHeight = gameInfoBlock.clientHeight;
                    gameInfoWidth = 0;
                }
                let gameHeaderHeight = 0;
                let gameHeader = document.getElementsByClassName('app-header')[0];
                if (document.getElementsByClassName('app-header')[0]) {
                    gameHeaderHeight = gameHeader.clientHeight + GAME_FIELD_PADDING;
                }
                if (this.parameters.extraOptions.pictures && this.showCartoon) {
                    if (this.index === 0) {
                        this.image = `/imgs/distracting-pictures/${Math.floor(Math.random() * 28)}.png`;
                    } else {
                        this.image = _.cloneDeep(this.nextImg);
                    }
                    this.nextImg = `/imgs/distracting-pictures/${Math.floor(Math.random() * 28)}.png`;
                    this.imgPosition.x = Math.random() * (window.innerWidth - MAX_IMAGE_WIDTH - gameInfoWidth);
                    this.imgPosition.y = Math.random() * (window.innerHeight - MAX_IMAGE_HEIGHT - gameHeaderHeight) + gameHeaderHeight + gameInfoHeight;
                }
                if (this.parameters.extraOptions.motion) {
                    let areaWidth = window.innerWidth - PLAY_BOX_PADDING_SUMMARY;
                    let areaHeight = window.innerHeight - gameHeaderHeight - GAME_FIELD_PADDING;
                    let numberBox = document.getElementsByClassName('digits-area__moving-num')[0];
                    if (numberBox && this.index > 0 && this.numbers[this.index]) {
                        let widthCoefficient = this.numbers[this.index].toString().length / this.numbers[this.index - 1].toString().length;
                        widthCoefficient = Math.floor(widthCoefficient * 10 + 1) / 10;
                        areaWidth -= (numberBox.clientWidth * widthCoefficient + gameInfoWidth);
                        areaHeight -= numberBox.clientHeight;
                        if (areaWidth < 0) {
                            areaWidth = 0;
                        }
                        if (areaHeight < 0) {
                            areaHeight = 0;
                        }
                        this.numPosition.x = Math.random() * (areaWidth + GAME_FIELD_PADDING * 2) + 50;
                        this.numPosition.y = Math.random() * (areaHeight) + gameHeaderHeight;
                    }
                }
                this.$emit('displayNumbers', this.index !== null)
                if (this.index !== null) {
                    return this.numbers[this.index];
                }
                return null;
            },
            soundObjects () {
                //todo: remove condition for locale and and necessary sounds
                if (
                        this.difficult <= MAX_VOICE_OVER_DIFFICULTY
                        && !this.parameters.extraOptions.x2
                        && this.parameters.extraOptions.voiceOver
                        && this.isVoiceOverAllowed
                ) {
                    let abs;
                    let soundObjects = [];
                    this.numbers.forEach(number => {
                        abs = Math.abs(number);
                        if (abs.toString(10).length <= MAX_VOICE_OVER_DIFFICULTY) {
                            let splittedNumber = this.splittableNumber ? this.splitNumber(abs) : [abs];
                            if (!this.isSpanish) {
                                splittedNumber.forEach(numberPart => {
                                    soundObjects.push({
                                        id: numberPart,
                                        src: `/sounds/digits/${this.locale}/${numberPart}.ogg`
                                    });
                                })
                            } else {
                                this.numbers.forEach(numberPart => {
                                    const sign = numberPart < 0 ? '' : '+';
                                    soundObjects.push({
                                        id: numberPart,
                                        src: `/sounds/digits/${this.locale}/${sign + numberPart}.mp3`
                                    });
                                })
                            }
                        }
                    });
                    return _.uniqBy(soundObjects, 'id');
                }
                return [];
            },
            isVoiceOverAllowed () {
                return !this.isX2
                        && this.parameters.speed >= this.minDurationForVoiceActing[this.difficult]
                        && this.isSingleScreen;
            },
            exampleActionClass () {
                if (this.isSingleScreen) {
                    let length = this.difficult;
                    if (this.parameters.fractions) {
                        length += this.parameters.fractionalPart;
                    }
                    if (length < 3) {
                        return 'number_font-large';
                    }
                    if (length === 3) {
                        return 'number_font-medium';
                    }
                    if (length === 4) {
                        return 'number_font-small';
                    }
                    if (length === 5) {
                        return 'number_font-x-small';
                    }
                    if (length === 6) {
                        return 'number_font-xx-small';
                    }
                    if (length === 7) {
                        return 'number_font-xxx-small';
                    }
                }
            },
            correctAnswerClass () {
                let length = this.difficult;
                if (this.parameters.fractions) {
                    length += this.parameters.fractionalPart;
                }
                if (length === 6) {
                    return 'correct-answer_font-small';
                }
                if (length === 7) {
                    return 'correct-answer_font-x-small';
                }
            },
            difficult () {
                switch (this.parameters.difficult) {
                    case 'Пятизначные цифры':
                        return 5;
                    case 'Четырехзначные цифры':
                        return 4;
                    case 'Трехзначные цифры':
                        return 3;
                    case 'Двузначные цифры':
                        return 2;
                    case 'Однозначные цифры':
                        return 1;
                }
            },
            splittableNumber () {
                return this.isBulgarian || this.isEnglish;
            },
            isBulgarian () {
                return this.locale === 'bg';
            },
            isEnglish () {
                return this.locale === 'en';
            },
            isRussian () {
                return this.locale === 'ru';
            },
            isSpanish () {
                return this.locale === 'es';
            },
            locale () {
                if (this.user && this.user.locale) {
                    return this.user.locale;
                }
                return 'ru';
            },
            oddIndex () {
                return !(this.index % 2);
            },
            multiplayerClass () {
                if (this.playersNumber === 1) {
                    return 'digits-area__result-one-player'
                }
                if (this.playersNumber === 2) {
                    return 'digits-area__result-two-players'
                }
                if (this.playersNumber === 3) {
                    return 'digits-area__result-three-players'
                }
                if (this.playersNumber === 4) {
                    return 'digits-area__result-four-players'
                }
                if (this.playersNumber === 5) {
                    return 'digits-area__result-five-players'
                }
                if (this.playersNumber === 6) {
                    return 'digits-area__result-six-players'
                }
                if (this.playersNumber === 7) {
                    return 'digits-area__result-seven-players'
                }
                if (this.playersNumber === 8) {
                    return 'digits-area__result-eight-players'
                }
            },
            portalName () {
                return this.playersNumber >= 1 ? `exitButtons${this.indexOfPlayBox}` : 'exitButtons';
            },
            currentNumberStyles () {
                if (this.currentNumberIndex % 2 === 0) {
                    return 'filter: saturate(130%)'
                } else if (this.currentNumberIndex % 2 === 1) {
                    return 'opacity: 0.7; filter: saturate(200%)'
                }
            },
            numberStyle () {
                return {
                    top: this.numPosition.y + 'px',
                    left: this.numPosition.x + 'px'
                }
            },
            imageStyle () {
                return {
                    top: this.imgPosition.y + 'px',
                    left: this.imgPosition.x + 'px'
                }
            },
        },
    }
</script>

<style scoped lang="scss">
    .pause-screen {
        margin-top: 20px;

        .svg-icon {
            color: $x-color-white;
            background-color: $hsl-color-blue-56_5;
            border-radius: 50%;
        }
    }

    .number {
        font-style: normal;
        font-weight: 500;
        font-size: 14vw;
        text-align: center;
        margin: 0;
        background: transparent;
        @include media($md) {
            font-size: 10.5vw;
        }
    }

    .number_blue {
        color: #2187FF;
    }

    .number_green {
        color: #6BBD6C;
    }

    .number_font-large {
        font-size: 20vw;
        @include media($md) {
            font-size: 16.5vw;
        }
    }

    .number_font-medium {
        font-size: 18vw;
        @include media($md) {
            font-size: 14.5vw;
        }
    }

    .number_font-small {
        font-size: 16vw;
    }

    .answer {
        display: flex;
        flex-direction: column;
        align-items: center;
        @media screen and (max-width: 575px) {
            margin-right: 10px;
        }
    }

    .answer__box {
        display: flex;
        align-items: center;
        position: relative;
    }

    .answer-label {
        font-weight: 500;
        font-size: 32px;
        line-height: 38px;
        color: #333333;
        margin-bottom: 10px;
        @media screen and (max-width: 767px) {
            font-size: 22px;
            line-height: 26px;
        }
        @media screen and (max-width: 359px) {
            font-size: 22px;
            line-height: 26px;
        }
    }

    .correct-answer {
        font-size: 32px;
        line-height: 38px;
        font-style: normal;
        font-weight: 500;
        color: #6BBD6C;
        margin-bottom: 20px;
        white-space: nowrap;
        text-align: center;
        @media screen and (max-width: 767px) {
            font-size: 22px;
            line-height: 26px;
            margin-bottom: 15px;
            white-space: normal;
            width: 200px;
        }
        @media screen and (max-width: 359px) {
            margin-bottom: 10px;
            white-space: normal;
            width: 200px;
        }

        &_font-small {
            font-size: 20px;
            @media screen and (max-width: 767px) {
                font-size: 18px;
            }
        }

        &_font-x-small {
            font-size: 19px;
            @media screen and (max-width: 767px) {
                font-size: 16px;
            }
        }
    }

    .answer-input {
        background: #ffffff;
        border: 2px solid #BDBDBD;
        border-radius: 5px;
        box-sizing: border-box;
        width: 280px;
        height: 80px;
        font-weight: normal;
        font-size: 52px;
        line-height: 62px;
        text-align: center;
        color: #333333;
        -moz-appearance: textfield;

        &::-webkit-inner-spin-button, &::-webkit-outer-spin-button {
            -webkit-appearance: none;
        }

        &:focus, &:active {
            border: 2px solid #2187FF;
            outline-width: 0;
        }

        &_incorrect {
            border: 2px solid #FF3D53;
            color: #FF3D53;
        }

        &_correct {
            border: 2px solid #6BBD6C;
            color: #6BBD6C;
        }

        @media screen and (max-width: 767px) {
            width: 100%;
            max-width: 230px;
            height: 60px;
        }
        &_with-result-icon {
            @media screen and (max-width: 767px) {
                max-width: 154px;
            }
        }
    }

    .result-icon {
        position: absolute;
        top: 25%;
        right: -45px;
        @media screen and (max-width: 767px) {
            top: 25%;
            right: -38px;
        }

        &_correct {
            color: $hsl-color-green-58;
        }

        &_incorrect {
            color: $hsl-color-red-62;
        }
        @media screen and (max-width: 575px) {
            display: none;
        }
    }

    .answer-button {
        margin-top: 20px;
    }

    .digits-area__result {
        width: 70%;
        @media screen and (max-width: 1399px) {
            width: 80%;
        }
        @media screen and (max-width: 991px) {
            width: 100%;
        }

        &_x2 {
            width: 100%;
            text-align: center;
        }
    }

    .digits-area__random-img-container {
        opacity: 0.7;
        position: relative;
        z-index: 100;
    }

    .digits-area__random-img {
        width: 150px;
        position: fixed;
    }

    .digits-area__random-num {
        position: relative;
        z-index: 40;
    }

    .digits-area__moving-num {
        position: fixed;
    }

    .digits-area__reaction-image {
        @media screen and (max-width: 819px) {
            width: 150px;
            height: 320px;
        }
        @media screen and (max-width: 575px) {
            width: 95px;
            height: 200px;
        }
        @include media($xlg) {
            display: none;
        }
        @include media($xl) {
            display: flex;
        }

        &_x2 {
            @media screen and (max-width: 819px) {
                width: 150px;
                height: 100px;
            }
            @media screen and (max-width: 575px) {
                width: 95px;
                height: 90px;
            }
        }
    }

    .digits-area__answer-block {
        display: flex;
        justify-content: space-between;
        align-items: center;
        @media screen and (max-width: 767px) {
            align-items: normal;
        }
    }

    .digits-area__answer {
        font-style: normal;
        font-weight: 500;
        font-size: 42px;
        line-height: 50px;
        text-align: center;

        &_correct {
            color: #6BBD6C;
        }

        &_incorrect {
            color: #FF3D53;
        }

        @media screen and (max-width: 767px) {
            font-size: 32px;
            line-height: 38px;
        }
        @media screen and (max-width: 575px) {
            font-size: 25px;
            line-height: 33px;
        }
    }

    .problem-wrapper, .my-answer {
        font-style: normal;
        font-weight: 500;
        font-size: 32px;
        line-height: 38px;
        text-align: center;
        color: #6BBD6C;
    }

    .problem-body {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
    }

    .result-container_x2 {
        display: flex;
        flex-direction: column;
        @media screen and (max-width: 767px) {
            justify-content: space-around;
            width: 100%;
        }
    }

    .problem-header_your-answer {
        padding-top: 20px;
    }

    .digits-area__answers {
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        min-width: calc(100% + 65px);
        @media screen and (max-width: 767px) {
            flex-direction: row;
            justify-content: space-around;
        }
    }
</style>

<style lang="scss" scoped>
    .play-box__game_x2 {
        .number_font-large {
            font-size: 18vw;
            @include media($md) {
                font-size: 20vw;
            }
            @include  media($xl) {
                font-size: 16vw;
            }
            @media screen and (min-width: 1800px) {
                font-size: 14vw;
            }
            @include media($xxl) {
                font-size: 13vw;
            }
        }

        .number_font-medium {
            font-size: 14vw;
            @include media($md) {
                font-size: 15vw;
            }
            @media screen and (min-width: 1800px) {
                font-size: 14vw;
            }
            @include media($xxl) {
                font-size: 13vw;
            }
        }

        .number_font-small {
            font-size: 11vw;
            @include media($md) {
                font-size: 12vw;
            }
        }

        .number_font-x-small {
            font-size: 9vw;
            @include media($md) {
                font-size: 10vw;
            }
        }

        .number_font-xx-small {
            font-size: 7vw;
            @include media($md) {
                font-size: 8vw;
            }
        }

        .number_font-xxx-small {
            font-size: 6vw;
            @include media($md) {
                font-size: 7vw;
            }
        }
    }
</style>

<style lang="scss" scoped>
    .digits-area__result-one-player, .digits-area__result-two-players {
        margin-top: 60px;
        @media screen and (min-width: 1600px) {
            margin-top: 100px;
        }

        .answer-label {
            font-size: 32px;
        }

        .answer-input {
            width: 250px;
            height: 80px;
        }

        .number {
            font-size: 82px;
            @include media($xl) {
                font-size: 100px;
            }
            @include media($xxl) {
                font-size: 140px;
            }
        }

        .result-container_multiplayer {
            margin-top: -50px;
            align-items: center;
            @include media($xl) {
                margin-top: -20px;
            }

            .digits-area__reaction-image-container {
                text-align: center;
            }

            .digits-area__reaction-image_x2 {
                max-width: 50%;
                @include media($xl) {
                    max-width: 70%;
                }
                @include media($xxl) {
                    max-width: 100%;
                    margin-bottom: 20px;
                }
            }

            .digits-area__answer {
                font-size: 26px;
                @include media($xxl) {
                    font-size: 32px;
                    margin-bottom: 20px;
                }
            }

            .digits-area__answer-number {
                margin-top: -15px;
            }

            .digits-area__result {
                width: 70%;
            }
        }

        .problem-header {
            font-size: 32px;
            @include media($xxl) {
                font-size: 52px;
                line-height: 60px;
            }
        }

        .problem-body, .my-answer {
            margin-top: 5px;
            font-size: 42px;
            @include media($xxl) {
                font-size: 60px;
                line-height: 70px;
            }
        }
    }

    .digits-area__result-three-players {
        margin-top: 40px;
        @media screen and (min-width: 1600px) {
            margin-top: 100px;
        }

        .answer-label {
            font-size: 20px;
            @include media($xl) {
                font-size: 22px;
            }
            @include media($xxl) {
                font-size: 32px;
            }
        }

        .answer-input {
            width: 180px;
            height: 50px;
            font-size: 32px;
            @include media($xl) {
                width: 250px;
                height: 60px;
            }
        }

        .number {
            font-size: 52px;
            @include media($xl) {
                font-size: 70px;
            }
            @include media($xxl) {
                font-size: 90px;
            }
        }

        .result-container_multiplayer {
            align-items: center;

            .digits-area__reaction-image-container {
                text-align: center;
            }

            .digits-area__reaction-image_x2 {
                max-width: 60%;
                @include media($xxl) {
                    max-width: 100%;
                    margin-bottom: 20px;
                }
            }

            .digits-area__answers {
                flex-direction: row;
                @include media($xl) {
                    flex-direction: column;
                }
            }

            .digits-area__answer {
                font-size: 20px;
                @include media($xl) {
                    font-size: 28px;
                }
                @include media($xxl) {
                    font-size: 32px;
                }

                &:first-child {
                    margin-right: 80px;
                    @include media($xl) {
                        margin-right: 0;
                    }
                }
            }

            .digits-area__answer-number {
                margin-top: -15px;
            }

            .digits-area__result {
                width: 70%;
            }
        }

        .problem-wrapper {
            @include media($xxl) {
                margin-top: 50px;
            }
        }

        .problem-header {
            font-size: 22px;
            @include media($xl) {
                font-size: 28px;
            }
            @include media($xxl) {
                font-size: 32px;
                line-height: 40px;
            }
        }

        .problem-body, .my-answer {
            font-size: 29px;
            @include media($xl) {
                font-size: 32px;
            }
            @include media($xxl) {
                font-size: 42px;
                line-height: 50px;
            }
        }
    }

    .digits-area__result-four-players, .digits-area__result-five-players,
    .digits-area__result-six-players, .digits-area__result-seven-players,
    .digits-area__result-eight-players {
        .answer {
            @media screen and (max-width: 1439px) {
                flex-direction: row;
                flex-wrap: wrap;
                justify-content: center;
                width: 70%;
                margin: 0 auto;
            }
        }

        .answer-button {
            @media screen and (max-width: 1439px) {
                padding: 10px 30px;
                margin-top: 20px;
            }
        }
    }

    .digits-area__result-one-players, .digits-area__result-two-players,
    .digits-area__result-three-players, .digits-area__result-four-players,
    .digits-area__result-five-players, .digits-area__result-six-players,
    .digits-area__result-seven-players, .digits-area__result-eight-players, {
        .answer-button {
            font-weight: 500;
            @media screen and (min-width: 1600px) {
                padding: 15px 55px;
            }
        }
    }

    .digits-area__result-four-players {
        margin-top: 20px;
        @include media($xxl) {
            margin-top: 120px;
        }

        .answer-label {
            font-size: 18px;
            margin: 0 10px 0 0;
            @include media($xl) {
                font-size: 22px;
            }
            @include media($xxl) {
                font-size: 32px;
            }
        }

        .answer-input {
            width: 180px;
            height: 50px;
            font-size: 28px;
            @include media($xl) {
                width: 250px;
                height: 60px;
            }
        }

        .number {
            font-size: 52px;
            height: auto;
            line-height: 60px;
            @include media($xl) {
                font-size: 100px;
                line-height: 100px;
            }
            @include media($xxl) {
                font-size: 70px;
            }
        }

        .result-container_multiplayer {
            margin-top: -10px;
            align-items: center;
            @include media($xxl) {
                margin-top: -60px;
            }

            .digits-area__reaction-image-container {
                text-align: center;
            }

            .digits-area__reaction-image_x2 {
                max-width: 50%;
                @include media($xl) {
                    max-width: 45%;
                }
                @include media($xxl) {
                    max-width: 100%;
                }
            }

            .digits-area__answers {
                flex-direction: row;
                margin-top: -80px;
                @include media($xlg) {
                    margin-top: 45px;
                }
                @include media($xl) {
                    margin-top: 0;
                }
                @include media($xxl) {
                    flex-direction: column;
                }
            }

            .digits-area__answer {
                font-size: 22px;

                &:first-child {
                    margin-right: 200px;
                    @include media($xl) {
                        margin-right: 140px;
                    }
                    @include media($xxl) {
                        margin-right: 0;
                    }
                }

                @include media($xxl) {
                    font-size: 32px;
                    line-height: 56px;
                    margin-bottom: 10px;
                }
            }

            .digits-area__answer-number {
                margin-top: -15px;
            }

            .digits-area__result {
                width: 70%;
            }
        }

        .problem-wrapper {
            margin-top: -25px;
            @include media($xl) {
                margin-top: 0;
            }
            @include media($xxl) {
                margin-top: 20px;
            }
        }

        .problem-header {
            font-size: 20px;
            padding-top: 0;
            @include media($xl) {
                font-size: 22px;
            }
            @include media($xxl) {
                font-size: 28px;
            }
        }

        .problem-body, .my-answer {
            font-size: 20px;
            line-height: 15px;
            margin-bottom: 5px;
            @include media($xl) {
                font-size: 22px;
                line-height: 25px;
                margin-bottom: 15px;
            }
            @include media($xxl) {
                font-size: 32px;
                line-height: 36px;
            }
        }
    }

    .digits-area__result-five-players, .digits-area__result-six-players {
        margin-top: 25px;
        @include media($xl) {
            margin-top: 15px;
        }

        .answer-label {
            font-size: 18px;
            margin: 0 10px 0 0;
            @include media($xl) {
                font-size: 22px;
            }
        }

        .answer-input {
            width: 120px;
            height: 40px;
            font-size: 22px;
            @include media($xl) {
                font-size: 26px;
                width: 250px;
                height: 60px;
            }
        }

        .number {
            font-size: 60px;
            height: auto;
            line-height: 60px;
            @include media($xl) {
                font-size: 70px;
                line-height: 70px;
            }
            @include media($xxl) {
                font-size: 90px;
                line-height: 100px;
            }
        }

        .result-container_multiplayer {
            margin-top: -10px;
            @include media($xl) {
                margin-top: 10px;
            }
            align-items: center;

            .digits-area__reaction-image-container {
                text-align: center;
            }

            .digits-area__reaction-image_x2 {
                max-width: 45%;
                @include media($xxl) {
                    max-width: 55%;
                }
            }

            .digits-area__answers {
                flex-direction: row;
                margin-top: -80px;
                @include media($xxl) {
                    margin-top: 0;
                }
                @include media($xlg) {
                    margin-top: 45px;
                }
            }

            .digits-area__answer {
                font-size: 18px;

                &:first-child {
                    margin-right: 160px;
                    @include media($xxl) {
                        margin-right: 200px;
                    }
                }

                @include media($xl) {
                    margin-bottom: 20px;
                }
                @include media($xxl) {
                    font-size: 22px;
                }
            }

            .digits-area__answer-number {
                margin-top: -15px;
            }

            .digits-area__result {
                width: 70%;
            }
        }

        .problem-wrapper {
            margin-top: -30px;
            @include media($xl) {
                margin-top: 0;
            }
            @include media($xxl) {
                margin-top: 15px;
            }
        }

        .problem-header {
            font-size: 20px;
            padding-top: 0;
            @include media($xl) {
                font-size: 22px;
            }
        }

        .problem-body, .my-answer {
            font-size: 20px;
            line-height: 15px;
            margin-bottom: 5px;
            @include media($xl) {
                font-size: 22px;
                margin-bottom: 20px;
            }
        }
    }

    .digits-area__result-seven-players, .digits-area__result-eight-players {
        margin-top: 20px;
        @media screen and (min-width: 1600px) {
            margin-top: 15px;
        }
        @include media($xxl) {
            margin-top: 10px;
        }

        .answer {
            @media screen and (max-width: 1439px) {
                width: 90%;
            }
        }

        .answer-label {
            font-size: 16px;
            margin: 0 10px 0 0;
            @include media($xl) {
                font-size: 20px;
            }
        }

        .answer-input {
            width: 100px;
            height: 40px;
            font-size: 18px;
            @include media($xl) {
                width: 180px;
                height: 50px;
                font-size: 22px;
            }
        }

        .answer-button {
            @media screen and (max-width: 1600px) {
                margin-top: 8px;
                padding: 10px 30px;
            }
        }

        .number {
            font-size: 40px;
            @include media($xl) {
                font-size: 50px;
            }
            @include media($xxl) {
                font-size: 70px;
            }
        }

        .result-container_multiplayer {
            margin-top: -28px;
            align-items: center;
            @include media($xl) {
                margin-top: 10px;
            }

            .digits-area__reaction-image-container {
                text-align: center;
            }

            .digits-area__reaction-image_x2 {
                max-width: 0;
                @include media($xl) {
                    max-width: 35%;
                }
                @include media($xxl) {
                    max-width: 45%;
                }
            }

            .digits-area__answers {
                flex-direction: row;
                margin-top: -15px;
                @include media($xl) {
                    margin-top: -60px;
                    margin-bottom: 20px;
                }
                @include media($xxl) {
                    margin-top: -15px;
                }
                @include media($xlg) {
                    margin-top: 10px;
                }
            }

            .digits-area__answer {
                font-size: 16px;
                line-height: 30px;
                margin-bottom: 20px;

                &:first-child {
                    margin-right: 80px;
                    @include media($xl) {
                        margin-right: 120px;
                        margin-bottom: 20px;
                    }
                    @include media($xxl) {
                        margin-right: 180px;
                        margin-bottom: 10px;
                    }
                }

                @include media($xxl) {
                    font-size: 22px;
                }
            }

            .digits-area__answer-number {
                margin-top: 0;
                line-height: 18px;
            }

            .digits-area__result {
                width: 70%;
            }
        }

        .problem-wrapper {
            margin-top: -15px;
            @include media($xl) {
                margin-top: 10px;
            }
            @include media($xxl) {
                margin-top: 40px;
            }
        }

        .problem-header {
            font-size: 16px;
            padding-top: 0;
            @include media($xl) {
                font-size: 22px;
                line-height: 25px;
            }
            @include media($xl) {
                line-height: 32px;
            }
        }

        .problem-body, .my-answer {
            font-size: 16px;
            line-height: 10px;
            margin-bottom: 5px;
            @include media($xl) {
                font-size: 22px;
                line-height: 25px;
            }
        }
    }

    .result_dictation {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .result__image {
        max-width: 100%;
        margin-bottom: 30px;
        @include media($md) {
            margin-bottom: 40px;
        }
    }

    .result__buttons {
        display: flex;
        margin-top: 20px;
    }

    .digits-area__answer-block_without-answers {
        display: flex;
        justify-content: center;
    }
</style>
